import { makeRequest } from '../../../../lib/api';
import {
  OrdersByClientRequest, UpdateOrderStatusRequest, TireFittingOrdersRequest,
  LossAdjustmentOrderListRequest,
} from '../../api/orderApi';

// TODO - после доработок бэка надо здесь прописать корректные пути
const ORDER_PATH = '/v1/orders';
const ORDER_PATH_V2 = '/v2/orders';
const CLIENTS_PATH = '/v1/clients';
const SCHEDULER_PATH = '/v1/users/scheduler';

const orderController = {
   
  getOrdersByClient: (request: OrdersByClientRequest): Promise<any> => {
    return makeRequest('post', `${ ORDER_PATH }/find`, request);
  },
   
  createLinkedOrder: (orderId: string, serviceId: number): Promise<any> => {
    return makeRequest('post', `${ ORDER_PATH }/create/linked/${ serviceId }`, { orderId });
  },

  // Заявки, по который есть шины на хранении (статус заявки "На хранении")
  getTyreInStorageOrders: (clientId: string) => {
    return makeRequest('get', `${ ORDER_PATH }/tire_storage/by_client/${ clientId }`);
  },

  // Информация по конкретному набору колёс на хранении, независимо от статуса заявки
  getTyreInStorageByOrderId: (orderId: string) => {
    return makeRequest('get', `${ ORDER_PATH }/tire_storage/by_order/${ orderId }`);
  },

  // Изменение статуса заявки
  updateOrderStatus: (request: UpdateOrderStatusRequest) => {
    return makeRequest('put', `${ ORDER_PATH }/${ request.id }`, { statusRefValueId: request.statusRefValueId });
  },

  getTireFittingOrders: (request: TireFittingOrdersRequest): Promise<any> => {
    return makeRequest('post', `${ ORDER_PATH }/tire_fitting`, request);
  },

  getLossAdjustmentOrders: (request: LossAdjustmentOrderListRequest): Promise<any> => {
    return makeRequest('post', `${ ORDER_PATH }/loss/adjustment`, request);
  },

  getSchedulerBoardList: (partnerOfficeId: string): Promise<any> => {
    return makeRequest('get', `${ SCHEDULER_PATH }/board/${ partnerOfficeId }`);
  },

  getOrderHistoryV2: (orderId: string): Promise<any> => {
    return makeRequest('get', `/api/audit/orders/${ orderId }`);
  },

  // Заказы клиента, выгруженные из 1С
  getOrders1C: (clientId: string): Promise<any> => {
    return makeRequest('get', `${ CLIENTS_PATH }/${ clientId }/1c`);
  },

  // Отправка клиенту SMS со ссылкой на самоосмотр (osmotr.avtoapp.ru/{ключ});
  // каждая отправка выдаёт новый ключ — прежняя ссылка перестаёт работать
  sendSelfInspectionLink: (orderId: string): Promise<any> => {
    return makeRequest('post', `${ ORDER_PATH_V2 }/${ orderId }/self_inspection/send_link`);
  },

  // Шаблон формы ошибок самоосмотра: подписи полей/слотов, повреждения и
  // сохранённые ошибки (ТЗ «Обработка ошибок» §4.1)
  getSelfInspectionReview: (orderId: string): Promise<any> => {
    return makeRequest('get', `${ ORDER_PATH_V2 }/${ orderId }/self_inspection/review`);
  },

  // Запрос досмотра: отмеченные ошибки уходят JSON-ом, бэк ставит статус
  // 751 «Доп.осмотр» и шлёт клиенту СМС с той же ссылкой (ТЗ §4.2)
  requestSelfInspectionRework: (
    orderId: string,
    payload: { comment: string | null; items: unknown[] }
  ): Promise<any> => {
    return makeRequest('post', `${ ORDER_PATH_V2 }/${ orderId }/self_inspection/request_changes`, payload);
  },
};

export { orderController };
